import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(private commonApiService: CommonApiService) {}

  getTargetAudience() {
    return this.commonApiService.get(APIURL.targetAudience);
  }

  getCountryCodeList() {
    return this.commonApiService.get(APIURL.countryList);
  }

  getIndustryList() {
    return this.commonApiService.get(APIURL.industryList);
  }

  getRoleList(payload: any = null) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.roleList, params);
  }

  getVideoTypeList() {
    return this.commonApiService.get(APIURL.videoType);
  }

  getToneAndStyle() {
    return this.commonApiService.get(APIURL.toneAndStyle);
  }

  getAIModelList(payload: any) {
    return this.commonApiService.post(APIURL.aiModel, payload);
  }

  getPlatformList() {
    return this.commonApiService.get(APIURL.platforms);
  }

  getScriptTypeList() {
    return this.commonApiService.get(APIURL.scriptType);
  }

  getAudioDeliveryTypeList() {
    return this.commonApiService.get(APIURL.audioDeliveryStyle);
  }

  getVisualStyleList() {
    return this.commonApiService.get(APIURL.visualStyle);
  }

  getSetupsList() {
    return this.commonApiService.get(APIURL.setups);
  }

  getImageStyleList() {
    return this.commonApiService.get(APIURL.imageStyle);
  }

  getConceptManifectMaster() {
    return this.commonApiService.get(APIURL.conceptManifectMaster);
  }

  getScriptOptions() {
    return this.commonApiService.get(APIURL.scriptOptions);
  }

  onAssetApproved(payload: any) {
    return this.commonApiService.post(APIURL.assetApproved, payload);
  }

  getEntityRefType(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.entityRefType, params);
  }

  getEntityGenOptions(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.entityGenOptions, params);
  }

  fetchParameters(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.fetchParameters, params);
  }
}
